export default __webpack_public_path__ + "static/media/General_01.7bb09481.webp";